// Banner severity ladder (Q2 — five levels).
// Order matters: index = importance. Higher-index banners stack above lower ones
// when multiple are active.
export const BANNER_SEVERITIES = [
  'info',
  'success',
  'warning',
  'critical',
  'maintenance',
] as const

export type BannerSeverity = (typeof BANNER_SEVERITIES)[number]

export interface SeverityStyle {
  /** Pastel background tint. */
  bg: string
  /** Body + icon color (deeper shade of the same hue). */
  text: string
  /** Hairline border, slightly darker than bg. */
  border: string
  icon: 'info' | 'check' | 'alert' | 'flame' | 'wrench'
}

// The bold prefix label (e.g. "Success!") is sourced from i18n
// (system.banner.labels.<severity>) and can be overridden per-banner.
//
// Brand-aligned palette: info/success/maintenance render as quiet brand
// chrome (mocha ground or ivory-dark ground with gold hairline). warning
// and critical intentionally break the brand to register as alerts.
export const SEVERITY_STYLES: Record<BannerSeverity, SeverityStyle> = {
  info: { bg: 'bg-mocha', text: 'text-ivory', border: 'border-gold/30', icon: 'info' },
  success: { bg: 'bg-ivory-dark', text: 'text-mocha', border: 'border-gold/40', icon: 'check' },
  warning: { bg: 'bg-amber-100', text: 'text-amber-900', border: 'border-amber-200', icon: 'alert' },
  critical: { bg: 'bg-rose-100', text: 'text-rose-900', border: 'border-rose-200', icon: 'flame' },
  maintenance: { bg: 'bg-mocha', text: 'text-ivory', border: 'border-gold/40', icon: 'wrench' },
}

export function severityRank(s: BannerSeverity): number {
  return BANNER_SEVERITIES.indexOf(s)
}
